export default "__VITE_ASSET__BFINpzDO__"